// extracted by mini-css-extract-plugin
module.exports = {"container":"_02712f2b3b--container--GYtww","icon":"_02712f2b3b--icon--Jg9PJ","rate":"_02712f2b3b--rate--SxOKW","rate-from":"_02712f2b3b--rate-from--PLc5_"};